import {getPagePreviewProfileQuery, useQuery} from "@redlink/services";
import {fa} from "./fa";
import {en} from "./en";

const languages = {
    fa,
    en
}

export const usePageLocale = ({pageName} = {}) => {
    const {data = {}} = useQuery(getPagePreviewProfileQuery, {variables: {pageName}});

    const {
        PageProfilePreview: {
            language = 'fa'
        } = {},
    } = data;

    const isRtl = language === 'fa';

    return {language, dictionary: languages[language] || {}, isRtl};
};